export default {
  tabs: {
    register: '会员注册',
    scan: '扫码设置',
    right: '会员权益说明',
    privacy: '会员隐私协议',
  },
  register: {
    conditions: '账号注册条件',
    phone: '手机号',
    phoneCode: '手机验证码',
    email: '邮箱',
    emailCode: '邮箱验证码',
    saveRule: '请至少勾选一种登录方式，并勾选对应的验证方式',
    savePhoneVerifyRule: '请勾选手机号里面的验证方式',
    saveEmailVerifyRule: '请勾选邮箱里面的验证方式',
  },
  scan: {
    label: '每扫码',
    countSuffix: '次，增加',
    growthSuffix: '成长值',
    countPlaceholder: '请输入次数',
    valuePlaceholder: '请输入',
    tooltip: '消费者扫描系统产品二维码时（有效扫码次数，即首次扫码是该消费者），会根据扫码次数来增加成长值',
    saveCountRule: '请输入扫码次数',
    saveValueRule: '请输入成长值',
  },
  agreement: {
    title: '权益说明',
    viewTip: '（用戶端可查看会员权益说明）',
    intro: '编辑会员协议内容，可针对不同语言维护各自的版本。',
    language: '语言',
    addLang: '添加多语言',
    delete: '删除',
    editorPlaceholder: '请输入内容',
    saveBeforeSwitch: '当前内容尚未保存，是否保存？',
  },
  rules: {
    title: '规则说明',
    intro1: '1、会员隐私协议主要用于向消费者解释说明会员中心如何收集、使用和共享用戶的个人信息，包括数据的用途、保存方式、安全性等方面的详细信息，在用戶进入会员中心功能时，需要同意该协议内容才能继续使用。',
    intro2: '2、如面向多国用戶使用，需分别维护不同国家语言的会员隐私协议，保障合规展示',
    intro: '编辑会员规则说明内容，可针对不同语言维护各自的版本。',
    titleField: '标题',
    language: '语言',
    addLang: '添加多语言',
    delete: '删除',
    saveBeforeSwitch: '当前内容尚未保存，是否保存？',
  },
  addI18nModal: {
    titleAgreement: '添加协议',
    titleRules: '添加规则说明',
    language: '语言',
    languagePlaceholder: '请选择语言',
    content: '内容',
  },
  deleteConfirm: '删除后不可恢复，确定要删除吗？',
};
